import React from 'react';
import Navbar from './Navbar';

  

const Header = ({user}) => {
    
    return (
        <div>    
           <Navbar user={user}/>
             
        </div>
    ); 
};

export default Header;
